<div class="dialog-title">Adjust Financial Limit / Interest Rate </div>
<form [formGroup]="formGrp">
  <div class="form-field">
    <mat-form-field>
      <input
        matInput
        currencyMask
        formControlName="financierLimit"
        placeholder="Financial Limit"
        required
      />
      <mat-error> Financial Limit is required.</mat-error>
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        currencyMask
        formControlName="interestRate"
        placeholder="Interest Rate"
      />
      <mat-error *ngIf="formGrp.controls.interestRate?.errors?.max">Interest Rate max is 100</mat-error>
    </mat-form-field>
  </div>
</form>

<div class="dialog-buttons">
  <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="primary" (click)="save()">Confirm</button>
</div>
